import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export const WORKOUT_ROW_HEIGHT = 36;

export default makeStyles((theme: MuiTheme) => ({
  loader: {
    flex: "auto"
  },
  tableContainer: {
    borderBottom: "1px solid #eeeeee",
    flexGrow: 1
  },
  workout: {
    fontSize: 12,
    lineHeight: 1,
    color: theme.palette.text.secondary
  },
  workoutRow: {
    height: WORKOUT_ROW_HEIGHT,
    boxShadow: "inset 0px -1px 0px 0px #eeeeee",
    "& .MuiTableCell-root": {
      borderBottom: "none"
    },
    "&:last-child": {
      boxShadow: "none"
    }
  },
  emptyDataHolder: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#c3c3c3",
    borderBottom: "1px solid #eeeeee",
    fontSize: 14
  },
  workoutCell: {
    padding: "0 16px",
    lineHeight: "normal",
    fontSize: 14,
    width: "25%",
    [theme.breakpoints.down("sm")]: {
      width: "auto",
      fontSize: 12,
      minHeight: 38,
      height: 38,
      padding: "8px 4px",
      "&:first-child": {
        paddingLeft: 16
      },
      "&:last-child": {
        paddingRight: 16
      }
    },
    [theme.breakpoints.up("md")]: {}
  },
  workoutCellVet: {
    width: "20%",
    textAlign: "left"
  },
  workoutDate: {
    color: "inherit"
  },
  workoutTime: {
    paddingRight: 10
  },
  workoutFacility: {
    color: "inherit",
    paddingLeft: 8
  },
  workoutDetails: {
    minWidth: 200,
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      fontSize: 12,
      padding: "8px 4px",
      minWidth: 0
    }
  },
  workoutReplay: {
    textAlign: "center"
  },
  workoutAnalysis: {
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  workoutScheduled: {
    color: "inherit",
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  workoutMenu: {
    textAlign: "right",
    color: "inherit",
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  workoutActive: {
    "& $workoutCell": {
      textTransform: "uppercase",
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      color: theme.palette.text.primary
    }
  },
  workoutActiveLastRow: {
    "& .MuiTableCell-root": {
      borderBottom: "1px solid rgba(186, 186, 186, 1)"
    }
  },
  icon: {
    fill: "#eeeeee",
    color: theme.palette.text.primary
  },
  iconActive: {
    fill: theme.palette.secondary.dark
  },
  tableHead: {
    color: theme.palette.text.primary,
    height: 36
  },
  tableHeadCell: {
    height: 36,
    padding: "4px 0",
    fontSize: 14
  },
  tableHeadDate: {
    fontFamily: "SuisseIntlMedium",
    textAlign: "left",
    paddingLeft: 16
  },
  tableHeadTrack: {
    textAlign: "left",
    fontFamily: "SuisseIntlRegular",
    paddingLeft: 8
  },
  tableHeadDetails: {
    textAlign: "center",
    fontFamily: "SuisseIntlRegular",
    minWidth: 114
  },
  tableHeadReplay: {
    textAlign: "center",
    fontFamily: "SuisseIntlRegular"
  },
  tableHeadAnalysis: {
    textAlign: "center",
    fontFamily: "SuisseIntlMedium",
    paddingRight: 16,
    paddingLeft: 16,
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  bulletIndicator: {
    fontSize: 8,
    margin: "0 2px"
  },
  dirtSurfaceIcon: {
    fontSize: 8,
    margin: "0 2px"
  },
  surfaceTurf: {
    border: `1px solid ${theme.palette.common.black}`,
    borderRadius: "50%",
    padding: 1,
    display: "inline-block",
    fontSize: 11,
    margin: "0 2px"
  },
  surfaceTurfInner: {
    border: `1px solid ${theme.palette.common.black}`,
    padding: 1,
    display: "inline-block",
    fontSize: 11,
    margin: "0 2px"
  },
  workoutTrack: {
    textAlign: "left",
    paddingLeft: 8
  },
  hidden: {
    display: "none"
  },
  workoutDetailsItem: {
    paddingRight: 4
  }
}));
